const { fountainRegex } = require('../regex')

class Paragraph {
  constructor (obj) {
    if (!obj || obj.name !== 'Paragraph') {
      console.warn('invalid paragraph object')
      return
    }

    const { Type, Alignment } = obj.attributes || {}

    if (Type) {
      this.type = Type
    }

    if (Alignment && Alignment === 'Center') {
      this.center = true
    }

    if (obj.dual) {
      this.dual = true
    }

    if (obj.dualMarker) {
      this.dualMarker = true
    }

    if (obj.scriptNote) {
      this.scriptNote = obj.scriptNote
    }

    this.children = obj.children || []
  }

  toString () {
    const { type, center, dualMarker, scriptNote } = this
    const textNodes = this.children.filter(isTextNode)

    if (textNodes.length === 0) return ''

    let text = processText(textNodes, {
      type,
      center,
      dualMarker,
      scriptNote
    })

    // add trailing newline for all paragraphs
    text = `${text}\n`

    // add leading newline for everything
    // except parenthetical, dialogue, and script note
    if (type !== 'Parenthetical' && type !== 'Dialogue' && !scriptNote) {
      text = `\n${text}`
    }

    return text
  }
}

function isTextNode (node) {
  return node && node.name === 'Text' && Array.isArray(node.text)
}

function processText (textNodes, options) {
  const { type, center, dualMarker, scriptNote } = options
  let prevStyles = []

  const text = textNodes
    // extract relevant info
    .map(node => {
      const { Style } = node.attributes || {}
      const styles = typeof Style === 'string' ? Style.split('+') : []
      const text = node.text.join('')

      return { text, styles }
    })
    // process styles
    .map((node, idx, arr) => {
      const { text, styles } = node
      let t = text

      const last = idx === arr.length - 1

      // 1. if style exists in previous but not current node, end style
      prevStyles.forEach(style => {
        const end = !styles.includes(style)
        switch (style) {
          case 'Underline':
            if (end) t = `_${t}`
            break
          case 'Bold':
            if (end) t = `**${t}`
            break
          case 'Italic':
            if (end) t = `*${t}`
            break
        }
      })

      // 2. if style exists here but not in previous, begin style
      // 3. if this is the last text node, end style
      styles.forEach(style => {
        const start = !prevStyles.includes(style)
        switch (style) {
          case 'Underline':
            if (start) t = `_${t}`
            if (last) t = `${t}_`
            break
          case 'Bold':
            if (start) t = `**${t}`
            if (last) t = `${t}**`
            break
          case 'Italic':
            if (start) t = `*${t}`
            if (last) t = `${t}*`
            break
        }
      })

      prevStyles = styles

      return t
    })
    // process script notes
    .map(t => {
      if (!scriptNote) return t

      const { opening, closing } = scriptNote

      // single line
      if (opening && closing) {
        return `\n[[ ${t} ]]`
      }

      // multiline
      if (opening) {
        return `\n/*\n${t}`
      }
      if (closing) {
        return `${t}\n*/`
      }

      return t
    })
    // merge text nodes, split into lines
    .join('')
    .split('\n')
    // process types
    .map(text => {
      let t = text

      switch (type) {
        case 'Scene Heading':
          t = t.toUpperCase()
          if (!fountainRegex.scene_heading.test(t)) {
            t = `.${t}`
          }
          break
        case 'Character':
          t = t.toUpperCase()
          break
        case 'Transition':
          t = t.toUpperCase()
          if (!/TO:$/.test(t)) {
            t = `> ${t}`
          }
          break
        case 'New Element':
          t = `# ${t}`
          break
      }

      return t
    })
    // process centering
    .map(line => {
      if (!center) return line
      return `> ${line} <`
    })

  // Character processing
  if (type === 'Character') {
    // no multiline character blocks in fountain
    let t = text.join(' ')

    // force character type
    if (!fountainRegex.character.test(t)) {
      t = `@${t}`
    }

    // process dual dialogue
    if (dualMarker) {
      t = `${t} ^`
    }

    return t
  }

  return text.join('\n')
}

module.exports = Paragraph
